// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"b9a77035","239":"e39fb35b","389":"a9ea9f2e","455":"a85b2e49","663":"c1c486d5","977":"23814c44","986":"c6e4a1c9"}[chunkId] + ".chunk.js";
};